module.exports = __webpack_public_path__ + "img/RJC_LP_head.bc07783.webp";